import { Router } from '@angular/router';
import { NavigationRoutes } from './app.routes.definition';
import { ComponentType } from '@angular/cdk/portal';
import { ModelCampaignListDetails } from '../models/campaign/campaign-list-details.model';
import { SendNotificationCreateMasterComponent } from '../modules/notifications/send-notification-create-master/send-notification-create-master.component';
import { GuardNullOrUndefined } from '../helpers/guard-null-undefined.helper';
import { ModelCampaign } from '../models/campaign/campaign.model';
import { GeolocationDetailsComponent } from '../modules/campaigns/geolocation-details/geolocation-details.component';
import { SendNotificationDetailsComponent } from '../modules/notifications/send-notification-details/send-notification-details.component';
import { NotificationDetailsComponent } from '../modules/campaigns/notification-details/notification-details.component';

export class NavigationHelper {

    constructor(private readonly router: Router) { }

    SideNav = {
        CampaignList: () => {
            this.router.navigate([`${NavigationRoutes.sideNav.children.campaignList.navigationPath}`]);
        },

        CampaignDetails: (organizationId: string, campaignId: string, displayCreateMessage = false, campaign?: ModelCampaign) => {
            this.router.navigate([`${NavigationRoutes.sideNav.children.campaignDetails.navigationPath}/${organizationId}/${campaignId}`, { campaign: JSON.stringify(campaign) }], 
                { queryParams: { displayCreateMessage: displayCreateMessage } });
        },

        CampaignInsights: (organizationId: string, campaignId: string, campaign?: ModelCampaignListDetails) => {
            this.router.navigate([`${NavigationRoutes.sideNav.children.campaignInsights.navigationPath}/${organizationId}/${campaignId}`, { campaign: JSON.stringify(campaign) }]);
        }
    }

    RightDrawer = {
        CampaignCreateMaster: (organizationId = 'undefined', campaignId = 'undefined') => {
            this.router.navigate([{ outlets: { rightDrawer: [`${NavigationRoutes.rightDrawer.campaignCreateMaster.navigationPath}`, organizationId, campaignId] } }]);
        },
        GeolocationDetails: (question: string) => {
            parameters[nameOf(GeolocationDetailsComponent)] = question;
            this.router.navigate([{ outlets: { rightDrawer: [`${NavigationRoutes.rightDrawer.geolocationDetails.path}`] } }]);
        },
        NotificationDetails: (question: string) => {
            parameters[nameOf(NotificationDetailsComponent)] = question;
            this.router.navigate([{ outlets: { rightDrawer: [`${NavigationRoutes.rightDrawer.notificationDetails.path}`] } }]);
        },
        SendNotification: (organizationId = 'undefined', campaignId = 'undefined') => {
            this.router.navigate([{ outlets: { rightDrawer: [`${NavigationRoutes.rightDrawer.sendNotificationCreateMaster.navigationPath}`, organizationId, campaignId] } }]);
        }
    }

    AddMedia() {
        this.router.navigate([`${NavigationRoutes.sideNav.children.campaignAdd.navigationPath}`]);
    }

    Dashboard(): void {
        this.router.navigate([`${NavigationRoutes.landingPage.navigationPath}`]);
    }

    NotFound(): void {
        this.router.navigate([`${NavigationRoutes.pageNotFound.navigationPath}`]);
    }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const parameters: { [key: string]: any } = {};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
Router.prototype.GetNavigationParameter = function <T>(component: ComponentType<any>): T {
    return parameters[nameOf(component)] as T;
};

//#endregion

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function nameOf<T extends new (...args: any[]) => any>(classType: T): string {
    return classType.name;
}